import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Breadcrumb trail: "Home > Section > Page". The last item is the current
 * page (aria-current). Same props as before; styled by chrome.css .ve-crumbs.
 *
 *   <Breadcrumbs items={[{ name: 'About Us', href: '/about-us/' }, { name: 'Our Awards' }]} />
 */
export interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
  /** Hide the leading Home crumb (when the page renders its own). */
  hideHome?: boolean;
}

export default function Breadcrumbs({ items, className = '', hideHome = false }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className={`ve-crumbs ${className}`.trim()}>
      <ol>
        {!hideHome && (
          <li>
            <Link to="/">Home</Link>
          </li>
        )}
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.name}-${index}`}>
              {(index > 0 || !hideHome) && <ChevronRight aria-hidden="true" focusable="false" />}
              {item.href && !isLast ? (
                <Link to={item.href}>{item.name}</Link>
              ) : (
                <span aria-current={isLast ? 'page' : undefined}>{item.name}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
